// extracted by mini-css-extract-plugin
module.exports = {"heading":"faqView_heading__2y7n6","searchField":"faqView_searchField__jwkOn","faq":"faqView_faq__Vm_Dp"};